<app-header (toggleMenubar)="toggleMenu()"></app-header>
<div class="ng-content">
  <!-- <div class="ng-content" [ngClass]="{'hidden-menu-content': !isMobileResolution && !isMenuVisible}"> cái này để giữ menu k tắt--> 
  <p-sidebar #menubar [visible]="isMenuVisible" position="left" [showCloseIcon]="false" styleClass="ng-menubar"
    [modal]="false">
    <!--     <app-menu (closeClicked)="isMobileResolution && isMenuVisible=$event" [itemsGLSetup]="itemsGLSetup cái này để giữ menu k tắt-->
    <app-menu (closeClicked)="isMenuVisible=$event" [itemsGLSetup]="itemsGLSetup"
      [itemsGLInput]="itemsGLInput" [itemsGLInquiry]="itemsGLInquiry" [itemsGLReport]="itemsGLReport"
      [itemsGLProcess]="itemsGLProcess" [itemsAPSetup]="itemsAPSetup" [itemsAPInput]="itemsAPInput"
      [itemsAPInquiry]="itemsAPInquiry" [itemsAPReport]="itemsAPReport" [itemsAPProcess]="itemsAPProcess"
      [itemsARSetup]="itemsARSetup" [itemsARInput]="itemsARInput" [itemsARInquiry]="itemsARInquiry"
      [itemsARReport]="itemsARReport" [itemsARProcess]="itemsARProcess" [itemsCASetup]="itemsCASetup"
      [itemsCAInput]="itemsCAInput" [itemsCAInquiry]="itemsCAInquiry" [itemsCAReport]="itemsCAReport"
      [itemsCAProcess]="itemsCAProcess" [itemsFASetup]="itemsFASetup" [itemsFAInput]="itemsFAInput"
      [itemsFAInquiry]="itemsFAInquiry" [itemsFAReport]="itemsFAReport" [itemsFAProcess]="itemsFAProcess"
      [itemsINSetup]="itemsINSetup" [itemsINInput]="itemsINInput" [itemsINReport]="itemsINReport"
      [itemsINProcess]="itemsINProcess" [itemsSASetup]="itemsSASetup" [itemsSAInput]="itemsSAInput"
      [itemsSAReport]="itemsSAReport" [itemsPOInput]="itemsPOInput" [itemsPOReport]="itemsPOReport"
      [itemsPOProcess]="itemsPOProcess" [itemsSOInput]="itemsSOInput" [itemsSOReport]="itemsSOReport"
      [itemsSOProcess]="itemsSOProcess" [itemsEISetup]="itemsEISetup" [itemsEIInput]="itemsEIInput" 
      [itemsEIProcess]="itemsEIProcess" [itemsSIInput]="itemsSIInput" [itemsUFInput]="itemsUFInput"
      [itemsSTInput]="itemsSTInput" [itemsSTSecurity]="itemsSTSecurity" [itemsBGInput]="itemsBGInput" [itemsBGReport]="itemsBGReport"
      [itemsSPInput]="itemsSPInput" [itemsSPReport]="itemsSPReport" [itemsCPCustomers]="itemsCPCustomers" [itemsCPFinancialStatement]="itemsCPFinancialStatement"
      [itemsCPVendors]="itemsCPVendors" [itemsCPRevenues]="itemsCPRevenues" [itemsCPCost]="itemsCPCost"
      [itemsCPAnalyze]="itemsCPAnalyze" [itemsCPManagements]="itemsCPManagements" [itemsCPHumanResources]="itemsCPHumanResources"
      [showGL]="showGL" [showAP]="showAP" [showAR]="showAR" [showCA]="showCA" [showFA]="showFA" [showIN]="showIN" 
      [showSO]="showSO" [showSA]="showSA" [showPO]="showPO" [showEI]="showEI" [showSI]="showSI" [showUF]="showUF" 
      [showST]="showST" [showBG]="showBG" [showSP]="showSP" [showAS]="showAS" [showHR]="showHR" [showCP]="showCP" className="np-menu">
    </app-menu>
  </p-sidebar>
  <reuse-tab></reuse-tab>
  <div style="margin-top: 15px;">
    <router-outlet></router-outlet>
  </div>
  
</div>
<app-footer></app-footer>
